import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd';
import RelatoriosIcon from '../assets/iconRelatorios.png';
import {
  ArrowLeftOutlined
} from '@ant-design/icons';
import './Relatorios.scss';
import { useNavigate } from 'react-router-dom';
import { LineChartOutlined, ExperimentOutlined } from '@ant-design/icons';
import { Chart } from "react-google-charts";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getNutrientesDiagnostico, getDiarioHistory, getRegistroExames } from '../service/api';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const data1 = [
  ["Month", "Ingestão de fenil (mg)", "Valor alvo (mg)"],
  ["Janeiro", 20, 30],
  ["Fevereiro", 45, 30],
  ["Março", 40, 30],
  ["Abril", 25, 30],
];
const data2 = [
  ["Month", "Ingestão de proteína (g)", "Valor alvo (g)"],
  ["Janeiro", 600, 400],
  ["Fevereiro", 500, 400],
  ["Março", 660, 400],
  ["Abril", 100, 400],
];

const optionsExameFenilalanina = {
  title: "Dosagem fenilalanina no sangue",
  curveType: "function",
  legend: { position: "bottom" },
};

const optionsExameTirosina = {
  title: "Dosagem tirosina no sangue",
  curveType: "function",
  legend: { position: "bottom" },
};

const data3 = [
  ["Month", "Resultado Exame", "Valor alvo mínimo", "Valor alvo máximo"],
  ["Janeiro", 2, 2, 10],
  ["Fevereiro", 4, 2, 10],
  ["Março", 11, 2, 10],
  ["Abril", 8, 2, 10],
];
const data4 = [
  ["Month", "Resultado Exame", "Valor alvo mínimo", "Valor alvo máximo"],
  ["Janeiro", 0.80, 0.54, 1.8],
  ["Fevereiro", 1.2, 0.54, 1.8],
  ["Março", 1.9, 0.54, 1.8],
  ["Abril", 1.4, 0.54, 1.8],
];

const optionsFenilalanina = {
  title: "Ingestão de Fenilalanina",
  curveType: "function",
  legend: { position: "bottom" },
};

const optionsProteina = {
  title: "Ingestão de Proteína",
  curveType: "function",
  legend: { position: "bottom" },
};
const Relatorios = () => {
  let navigate = useNavigate();
  const [openConsumo, setOpenConsumo] = useState(false)
  const [openExames, setOpenExames] = useState(false)
  const [nutrientes, setNutrientes] = React.useState("");
  const [nutrientesList, setNutrientesList] = React.useState([]);
  const [diarioList, setDiarioList] = React.useState([]);
  const [examesObj, setExamesObj] = React.useState({});
  const [exames, setExames] = React.useState(1);
  const [userId, setUserId] = useState("")
  const [open, setOpen] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [graficosConsumo, setGraficosConsumo] = useState({})
  const [graficosExames, setGraficosExames] = useState({})
  const [loading, setLoading] = useState(false)

  const handleChange = (event) => {
    generateGrafico(event.target.value)
    setNutrientes(event.target.value);
  };

  const handleChange2 = (event) => {
    generateExamesGrafico(event.target.value)
    setExames(event.target.value);
  };

  React.useEffect(() => {
    const userId = localStorage.getItem('userId')
    if (!userId) {
      navigate('/login', { replace: true })
    }
    setUserId(userId)
  }, [])

  const onClickBack = () => {
    if (openConsumo) {
      setOpenConsumo(false)
    } else if (openExames) {
      setOpenExames(false)
    } else {
      navigate('/', { replace: true });
    }
  }

  const removeAcento = (text) => {
    text = text.toLowerCase();
    text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a');
    text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e');
    text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i');
    text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o');
    text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u');
    text = text.replace(new RegExp('[Ç]', 'gi'), 'c');
    return text;
  }

  const generateExamesGrafico = async (exame) => {
    setLoading(true)
    const monthNumber = {
      1: "Janeiro",
      2: "Fevereiro",
      3: "Março",
      4: "Abril",
      5: "Maio",
      6: "Junho",
      7: "Julho",
      8: "Agosto",
      9: "Setembro",
      10: "Outubro",
      11: "Novembro",
      12: "Dezembro",
    }
    const actualDate = new Date()

    var dataGen = []
    dataGen.push(["Month", "Resultado Exame", "Valor alvo mínimo", "Valor alvo máximo"],)

    for (var i = 1; i <= actualDate.getMonth() + 1; i++) {
      dataGen.push([monthNumber[i], null, parseFloat(examesObj[exame][0].referencia_inicial.replace(',', '.')), parseFloat(examesObj[exame][0].referencia_final.replace(',', '.'))])
    }

    var data = dataGen

    var exames = examesObj[exame]
    await exames.map(item => {
      const date = new Date(item.dataexame)

      const itemMonth = date.getMonth() + 1

      data[itemMonth][1] = parseFloat(item.resultado.replace(',', '.'))
      data[itemMonth][2] = parseFloat(item.referencia_inicial.replace(',', '.'))
      data[itemMonth][3] = parseFloat(item.referencia_final.replace(',', '.'))
    })
    const aux = {
      data: data,
      options: {
        title: `Dosagem ${exame} no sangue`,
        curveType: "function",
        legend: { position: "bottom" },
      }
    }
    setGraficosExames(aux)
    setLoading(false)
  }

  const generateGrafico = async (nutriente) => {
    setLoading(true)
    const monthNumber = {
      1: "Janeiro",
      2: "Fevereiro",
      3: "Março",
      4: "Abril",
      5: "Maio",
      6: "Junho",
      7: "Julho",
      8: "Agosto",
      9: "Setembro",
      10: "Outubro",
      11: "Novembro",
      12: "Dezembro",
    }
    var refPerMonth = {
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
      10: 0,
      11: 0,
      12: 0,
    }

    var mediaDia = [];

    const actualDate = new Date()

    var dataGen = []
    dataGen.push(["Month", `Ingestão de ${nutriente}`, `Valor alvo`])
    mediaDia.push(["", {}, 0])
    for (var i = 1; i <= actualDate.getMonth() + 1; i++) {
      dataGen.push([monthNumber[i], 0, 0])
      mediaDia.push([monthNumber[i], {}, 0])
    }

    var data = dataGen

    var nut
    nutrientesList.map((item) => {
      if (item.nomenutriente == nutriente) {
        nut = item
      }
    })

    console.log(diarioList)
    diarioList.forEach((ref, index) => {
      const date = new Date(ref.date_diario)
      const day = date.getDate()
      const refMonth = date.getMonth() + 1

      const nutrienteText = removeAcento(nutriente)
      const nutriName = nutrienteText == "fenilalanina" ? "fenilanina" : nutrienteText
      var quantNutriente = ref[nutriName] == "ND" || ref[nutriName] == "" ? 0 : parseFloat(ref[nutriName].replace(',', '.'))
      var quantConsumido = parseFloat(ref.consumido.replace(',', '.'))

      const ingestaoNutriente = (quantNutriente * quantConsumido) / 100;

      // const ingestaoMedia = (ingestaoNutriente + data[refMonth][1])

      // data[refMonth][1] = ingestaoMedia

      mediaDia[refMonth][1][day] = mediaDia[refMonth][1][day] ? mediaDia[refMonth][1][day] + ingestaoNutriente : ingestaoNutriente
      // try {
      //   mediaDia[refMonth][day] = mediaDia[refMonth][day] + ingestaoNutriente
      // } catch (error) {
      //   mediaDia[refMonth] = {day: ingestaoNutriente}
      // }

      for (var i = 1; i <= actualDate.getMonth() + 1; i++) {
        data[i][2] = parseFloat(nut.recomendacaodiaria.replace(',', '.'))
      }

      const refpos = index + 1
      if (refpos == diarioList.length) {
        let dataset = []
        mediaDia.forEach((elem, i) => {
          if (i > 0) {
            const diasComRefeicao = Object.keys(elem[1]).length
            data[i][1] = 0
            if (diasComRefeicao > 0) {
              Object.keys(elem[1]).forEach((e, pos) => {
                data[i][1] = elem[1][e] + data[i][1]
              })
              data[i][1] = data[i][1] / diasComRefeicao
            }
          }
          //calcular a media do mes pelos dias e popular data[]
          const count = i + 1
          if (count == mediaDia.length) {
            data.forEach((elem, i) => {

              dataset.push(elem)

              const pos = i + 1

              if (pos == data.length) {
                console.log(dataset)
                var aux = graficosConsumo
                aux[nutriente] = {
                  nutriente: nutriente,
                  data: dataset,
                  options: {
                    title: `Ingestão de ${nutriente}`,
                    curveType: "function",
                    legend: { position: "bottom" },
                  }
                }

                setGraficosConsumo(aux)
                setLoading(false)
              }
            })
          }
        })

      }
    })
  }

  const onClickOpenConsumo = async () => {
    await getNutrientesDiagnostico(userId).then(async (response) => {
      if (response) {
        setNutrientesList(response)
        await getDiarioHistory(userId).then(responseDiario => {
          if (responseDiario) {
            setDiarioList(responseDiario)
          }
        }).catch(error => {
          console.log(error)
          if (error == 404) {
            setErrorMessage("Você precisa cadastrar um Diagnóstico para visualizar relatórios")
            setOpen(true)
          } else {
            setErrorMessage("Erro ao carregar grafico, tente novamente mais tarde")
            setOpen(true)
          }
        })
      }
    }).catch(error => {
      console.log(error)
      if (error == 404) {
        setErrorMessage("Você precisa cadastrar um Diagnóstico para visualizar relatórios")
        setOpen(true)
      } else {
        setErrorMessage("Erro ao carregar grafico, tente novamente mais tarde")
        setOpen(true)
      }
    })
    setOpenConsumo(true)
  }

  const onClickOpenExames = async () => {
    await getRegistroExames(userId).then(async (response) => {
      if (response) {
        const aux = {}
        response.map(item => {
          if (aux[item.nome]) {
            var arr = aux[item.nome]
            arr.push(item)
            aux[item.nome] = arr

          } else {
            var arr = []
            arr.push(item)
            aux[item.nome] = arr
          }
        })
        setExamesObj(aux)
      }
    }).catch(error => {
      console.log(error)
      if (error == 404) {
        setErrorMessage("Você precisa cadastrar um Exames para visualizar relatórios")
        setOpen(true)
      } else {
        setErrorMessage("Erro ao carregar grafico, tente novamente mais tarde")
        setOpen(true)
      }
    })
    setOpenExames(true)
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  return (
    <div className='relatorios'>
      <Row>
        <Col span={24} className='relatorios__header'>
          <ArrowLeftOutlined className='relatorios__icons' onClick={onClickBack} />
          <img src={RelatoriosIcon} alt='' className='relatorios__logo' />
          <p className='relatorios__title'>Relatórios</p>
        </Col>
      </Row>

      <div className='relatorios__body'>
        {
          openConsumo ?
            <div>
              <div className="relatorios__bodyTitle">
                <p>Consumo Alimentar</p>
              </div>
              <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ marginBottom: 20 }}>
                <InputLabel id="demo-simple-select-standard-label">Nutriente</InputLabel>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  value={nutrientes}
                  onChange={handleChange}
                  label="Nutriente"
                >
                  {
                    nutrientesList.map(function (item, i) {
                      return (
                        <MenuItem value={item.nomenutriente}>
                          <em>{item.nomenutriente}</em>
                        </MenuItem>
                      )
                    })
                  }
                </Select>
              </FormControl>
              {
                nutrientes == "" ?
                  <div>
                  </div>
                  :
                  <div>
                    {
                      loading ?
                        <p>Carregando Gráfico</p>
                        :
                        <Chart
                          chartType="LineChart"
                          width="100%"
                          height="400px"
                          data={graficosConsumo[nutrientes].data}
                          options={graficosConsumo[nutrientes].options}
                        />
                    }
                  </div>
              }

            </div>
            : openExames ?
              <div>
                <div className="relatorios__bodyTitle">
                  <p>Exames Bioquímicos</p>
                </div>

                <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }} style={{ marginBottom: 20 }}>
                  <InputLabel id="demo-simple-select-standard-label">Exames</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={exames}
                    onChange={handleChange2}
                    label="Exames"
                  >
                    {
                      Object.keys(examesObj).map(function (item, i) {
                        return (
                          <MenuItem value={examesObj[item][0].nome}>
                            <em>{examesObj[item][0].nome}</em>
                          </MenuItem>
                        )
                      })
                    }
                  </Select>
                </FormControl>
                {
                  !graficosExames.data ?
                    <div>
                    </div>
                    :
                    <div>
                      {
                        loading ?
                          <p>Carregando Gráfico</p>
                          :
                          <Chart
                            chartType="LineChart"
                            width="100%"
                            height="400px"
                            data={graficosExames.data}
                            options={graficosExames.options}
                          />
                      }
                    </div>
                }
              </div>
              :
              <div>
                <div className='relatorios__button' onClick={() => onClickOpenConsumo()}>
                  <LineChartOutlined style={{ marginRight: 10 }} />
                  Gráficos de Consumo Alimentar
                </div>
                <div className='relatorios__button' onClick={() => onClickOpenExames()}>
                  <ExperimentOutlined style={{ marginRight: 10 }} />
                  Exames Bioquímicos
                </div>
              </div>
        }

      </div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>{errorMessage}</Alert>
      </Snackbar>
    </div>
  )
}

export default Relatorios
